module.exports = __webpack_public_path__ + "static/media/BIFI-FTM.2b6953f5.png";